import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { ScrollArea } from '@ohif/ui-next';

const stickyClasses = 'sticky top-0';
const notStickyClasses = 'relative';

const NavBar = ({ className, children, isSticky }) => {
  const scrollAreaRef = useRef(null);
  useEffect(() => {
    const scrollContainer = scrollAreaRef.current?.querySelector(
      '[data-radix-scroll-area-viewport]'
    );
    if (scrollContainer) {
      const handleResize = () => {
        scrollContainer.dispatchEvent(new Event('scroll'));
      };
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }
  }, [children]);

  return (
    <div
      className={classnames(
        'z-20 flex flex-row border-black bg-[#27272B] px-1',
        isSticky ? stickyClasses : notStickyClasses,
        className
      )}
      style={{ minHeight: '48px' }}
    >
      <ScrollArea
        ref={scrollAreaRef}
        className="flex whitespace-nowrap"
        style={{ flex: 1 }}
      >
        {children}
      </ScrollArea>
    </div>
  );
};

NavBar.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  isSticky: PropTypes.bool,
};

export default NavBar;
